<template>
  <div class="db-tw-mb-9 db-tw-grid md:db-tw-grid-cols-[2fr_1fr] md:db-tw-gap-3">
    <div v-if="options.length">
      <DbSelectCustom
        :modelValue="type"
        :options="optionsWithEmptyValue"
        :inputAttrs="{ required: isMandatoryEventType }"
        v-on:update:model-value="$emit('update:type', $event)"
      >
        {{ labelType }}
        <template
          v-if="v$.fieldType.$error"
          v-slot:error
        >
          <DbRfpErrors :errors="v$.fieldType.$errors" />
        </template>
      </DbSelectCustom>
    </div>
    <div>
      <DbInput
        :modelValue="nbAttendees"
        class="db-tw-w-[49%] db-tw-mt-8 md:db-tw-w-full md:db-tw-mt-0"
        :inputAttrs="{
          type: 'number',
          min: 0,
          required: isMandatoryNbAttendees,
        }"
        v-on:update:model-value="$emit('update:nbAttendees', $event)"
      >
        {{ labelNbAttendees }}
        <template
          v-if="v$.fieldNbAttendees.$error"
          v-slot:error
        >
          <DbRfpErrors :errors="v$.fieldNbAttendees.$errors" />
        </template>
      </DbInput>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf, numeric, maxLength } from '@/utils/i18n-validators'
import type { Options } from '@/types/components/combobox'
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    type?: string
    nbAttendees?: string
    options: Options
    labelType: string
    labelNbAttendees: string
    isMandatoryEventType: boolean
    isMandatoryNbAttendees: boolean
  }>(),
  {
    type: '',
    nbAttendees: '',
  },
)

defineEmits<{
  (e: 'update:type', eventNbAttendees: string | number): void
  (e: 'update:nbAttendees', eventNbAttendees: string): void
}>()

const { t } = useI18n()
const optionsWithEmptyValue = computed(() => {
  const defaultValue = {
    label: t('Select item'),
    value: '',
  }
  return [defaultValue, ...props.options]
})

const state = computed(() => {
  return {
    fieldType: props.type,
    fieldNbAttendees: props.nbAttendees,
  }
})

const rules = computed(() => {
  return {
    fieldType: { required: requiredIf(props.isMandatoryEventType), maxLengthValue: maxLength(50) },
    fieldNbAttendees: { required: requiredIf(props.isMandatoryNbAttendees), numeric },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>
